// https://github.com/uuidjs/uuid/blob/main/src/regex.js
const uuidRegex = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

export const validateUuid = uuid => {
  return typeof uuid === 'string' && uuidRegex.test(uuid);
};
